enum PARAMETRE_TASK_PLANIFICATION {
  EVERY_X_MINUTE = "everyXMinute",
  EVERY_HOUR_AT_MINUTE_X = "everyHourAtMinuteX",
  SPECIFIED_TIME = "specifiedTime",
  PERSONALIZED = "personalized",
}

export default PARAMETRE_TASK_PLANIFICATION;
